import * as React from "react";
import { SVGProps } from "react";
const SvgUser = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 11c2.5 0 4.5-2 4.5-4.5S18.5 2 16 2s-4.5 2-4.5 4.5 2 4.5 4.5 4.5Zm9 6c0-2.2-1.8-4-4-4H11c-2.2 0-4 1.8-4 4v10c0 .6.4 1 1 1s1-.4 1-1V17c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2v10c0 .6.4 1 1 1s1-.4 1-1V17Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgUser;
